// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");

function empty(param) {
  return {
          id: undefined,
          fromId: "",
          default: false
        };
}

function id(t) {
  return t.id;
}

function fromId(t) {
  return t.fromId;
}

function $$default(t) {
  return t.default;
}

function setFromId(t, fromId) {
  return {
          id: t.id,
          fromId: fromId,
          default: t.default
        };
}

function toggledefault(t) {
  return {
          id: t.id,
          fromId: t.fromId,
          default: !t.default
        };
}

function decode(json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          fromId: Json_decode.field("from_id", Json_decode.string, json),
          default: Json_decode.field("default", Json_decode.bool, json)
        };
}

function encode(t) {
  return Json_encode.object_({
              hd: [
                "from_id",
                t.fromId
              ],
              tl: {
                hd: [
                  "default",
                  t.default
                ],
                tl: /* [] */0
              }
            });
}

exports.empty = empty;
exports.id = id;
exports.fromId = fromId;
exports.default = $$default;
exports.__esModule = true;
exports.setFromId = setFromId;
exports.toggledefault = toggledefault;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
